import checkout from "./form";

const {
  formField: {
    period,
    firstTime,
    additional,
    taxpayerName,
    taxId,
    city,
    district,
    ward,
    village,
    road,
    apartment,
    taxAgentName,
    taxAgentId,
    taxAgentContract,
    daytaxAgentContract,

    startingTime,
    timeOfChange,
    taxExemption,
    compulsoryTax,
    taxPrice,
    taxMustBePaid,

    fullName,
    certificate,
    signer,
    timeSign,
  },
} = checkout;

const initialValues = {
  [period.name]: "",
  [certificate.name]: "",
  [fullName.name]: "",
  [firstTime.name]: false,
  [signer.name]: "",
  [additional.name]: "",
  [city.name]: "",
  [district.name]: "",
  [ward.name]: "",
  [taxId.name]: "",
  [taxpayerName.name]: "",
  [timeSign.name]: "",
  [village.name]: "",
  [road.name]: "",
  [apartment.name]: "",
  [taxAgentName.name]: "",
  [taxAgentContract.name]: "",
  [startingTime.name]: "",
  [timeOfChange.name]: "",
  [taxExemption.name]: "",
  [compulsoryTax.name]: "",
  [taxPrice.name]: "",
  [taxMustBePaid.name]: "",
  [taxAgentId.name]: "",
  [daytaxAgentContract.name]: "",
};

export default initialValues;
